import "./scss/WheelOfPrizes.scss";
import Lottie from 'react-lottie-player'
import lostAnimationOG from '../animations/neutral.json'
import SubmitButton from "./SubmitButton";

const hexToRGB = function (color) {
	if(typeof color !== 'string') return [0,0,0];
	color = color.replace('#', '');
	const MAX = color.length===3?15:255;
	const len = color.length===3?1:2;
	const r = parseInt(color.substring(0, len), 16);
	const g = parseInt(color.substring(len, len*2), 16);
	const b = parseInt(color.substring(len*2, len*3), 16);
	return [r/MAX, g/MAX, b/MAX];
}

const replaceColor = function(color, lostAnimationOG) {
	const c = hexToRGB(color);
	lostAnimationOG.assets.forEach(function(asset){
		asset.layers.forEach(function(layer){
			layer.shapes.forEach(function(shape){
				shape.it.forEach(function(it){
					if(it.mn?.toLowerCase().includes('fill')){
						it.c.k.forEach(function(k){
							k.s = c;
						});
					}
				});
			});
		});
	});
	return lostAnimationOG;
}

function WheelOfPrizesMakisLost({ next, data, primaryTextColor, button }) {
	return (
		<>
			<div style={{ marginTop: data?.marginTop }} className="wheel_ofprizes-lost" style={{background: 'none', backdropFilter: 'none'}}>
				<div style={{
					backgroundColor: 'black',
					color: 'white',
					maxWidth: '400px',
					margin: '100px auto',
					padding: 20,
					fontSize: '26px',
					fontWeight: 900,
					fontStyle: 'italic',
					borderRadius: '8px',
				}}>
					Η ενέργεια έχει ολοκληρωθεί. Ευχαριστούμε για τη συμμετοχή σας.
				</div>
			</div>
			<div className="text--center" style={{ position: 'fixed', bottom: '64px', left: 0, right: 0 }} >
				<SubmitButton
					text={"Επόμενο"}
					size={button?.submitSize}
					onSubmit={next}
					buttonStyle={{borderRadius:button?.borderRadius, background: data?.buttonColor, color: data?.textColor}}
				/>
			</div>
		</>
	);
};
export default WheelOfPrizesMakisLost;
